import provideRoutes from './provider/';

const routes = [
  {
    path: 'provider',
    component: () => import('@/views/provider/ProviderWrapper.vue'),
    children: [
      {
        path: '/provider/menu',
        name: 'provider',
        component: () => import('@/views/provider/Menu.vue'),
      },
      {
        path: '',
        name: 'ProviderSearch',
        component: () => import('@/views/provider/search/ProviderSearch.vue'),
      },
      {
        path: '/provider/servicelocation',
        name: 'ServiceLocation',
        component: () =>
          import(
            '@/views/provider/serviceLocation/ProviderServiceLocation.vue'
          ),
      },
      {
        path: '/provider/servicelocation/add/:fiscalYearId/:companyId',
        name: 'AddProviderServiceLocation',
        component: () =>
          import(
            '@/views/provider/serviceLocation/AddProviderServiceLocation.vue'
          ),
      },
      {
        path: '/provider/online-registry',
        name: 'ProviderOnlineRegistry',
      },
      {
        path: '/provider/servicelocation/edit/:locationFiscalYearId',
        name: 'EditProviderServiceLocation',
        component: () =>
          import(
            '@/views/provider/serviceLocation/EditProviderServiceLocation.vue'
          ),
      },
      {
        path: '/provider/create/:companyTypeId?',
        name: 'provider-create',
        component: () =>
          import('@/views/provider/management/ProviderCreate.vue'),
      },
      {
        path: '/provider/amendment/:contractId/:companyId/:fiscalYearId',
        name: 'provider-amendment',
        component: () => import('@/views/provider/management/amendment/Master'),
      },
      {
        path: '/provider/edit/:fiscalYearId/:companyId/',
        name: 'provider-edit',
        component: () => import('@/views/provider/management/ProviderEdit.vue'),
        children: [
          {
            path: 'contracts',
            name: 'resultContracts',
            components: {
              contractManagement: () =>
                import('@/views/provider/management/contract/ResultContracts'),
            },
          },
          {
            path: 'medicaid-eligibility',
            name: 'medicaid-eligibility',
            components: {
              contractManagement: () =>
                import(
                  '@/views/provider/management/_components/MedicaidEligibility'
                ),
            },
          },
          {
            path: 'contract/:contractId?',
            name: 'contractAddEdit',
            components: {
              contractManagement: () =>
                import('@/views/provider/management/contract/ContractAddEdit'),
            },
          },
          {
            path: 'sifde-main',
            name: 'sifde-main',
            components: {
              sifdeManagement: () =>
                import('@/components/common/sifde/Main.vue'),
            },
          },
        ],
      },
      {
        path: '/evaluators/evaluatormanagement',
        name: 'evaluators-evaluatormanagement',
        component: () =>
          import('@/views/provider/evaluators/EvaluatorManagement'),
      },
      {
        path: '/provider/availableSpaces',
        component: () => import('@/views/provider/availableSpaces/Wrapper.vue'),
        children: [
          {
            path: '/provider/availableSpaces',
            name: 'AvailableSpaces',
            component: () =>
              import('@/views/provider/availableSpaces/AvailableSpaces.vue'),
          },
          {
            path: '/provider/spaceManagement/:fiscalYearId/:specialistId/',
            name: 'SpaceManagement',
            component: () =>
              import('@/views/provider/availableSpaces/SpaceManagement.vue'),
          },
        ],
      },
      {
        path: '/provider/specialists',
        component: () => import('@/views/provider/specialists/Wrapper.vue'),
        children: [
          {
            path: 'search',
            name: 'search-specialist',
            component: () => import('@/views/provider/specialists/Search.vue'),
          },
          {
            path: 'change/:specialistId/:companyId',
            name: 'change-specialist',
            component: () => import('@/views/provider/specialists/Change.vue'),
          },
          {
            path: 'specialist/:specialistId?/:companyId?/:fiscalYearId?',
            name: 'specialist-management',
            component: () =>
              import(
                '@/views/provider/specialists/management/ManageSpecialist'
              ),
            props: true,
          },
          {
            path: 'specialist/dispensation-request/:dispensationRequestId?',
            name: 'dispensation-request',
            component: () =>
              import(
                '@/views/provider/specialists/dipensation-request/DispensationRequest'
              ),
            meta: {
              title: 'Solicitud de Dispensa',
            },
          },
        ],
      },
      {
        path: '/provider/numbersofaccount',
        component: () => import('@/views/provider/accountNumber/Wrapper.vue'),
        children: [
          {
            path: 'search',
            name: 'AccountNumberHistory',
            component: () =>
              import('@/views/provider/accountNumber/AccountNumberHistory.vue'),
          },
          {
            path: '/provider/addnumbersofaccount',
            name: 'AccountNumberAdd',
            component: () =>
              import('@/views/provider/accountNumber/AccountNumberAdd.vue'),
          },
          {
            path: '/provider/addnumbersofaccount/:id',
            name: 'AccountNumberEdit',
            component: () =>
              import('@/views/provider/accountNumber/AccountNumberAdd.vue'),
          },
        ],
      },
      {
        path: '/provider/practitionerintern',
        component: () =>
          import('@/views/provider/practitionerIntern/Wrapper.vue'),
        children: [
          {
            path: '/provider/practitionerintern',
            name: 'PractitionerIntern',
            component: () =>
              import(
                '@/views/provider/practitionerIntern/PractitionerIntern.vue'
              ),
          },
          {
            path: '/provider/practitionerinternadd',
            name: 'PractitionerInternAdd',
            component: () =>
              import(
                '@/views/provider/practitionerIntern/PractitionerInternAdd.vue'
              ),
          },
          {
            path:
              '/provider/practitionerinternedit/:fiscalYearId/:practitionerId/:companyId?',
            name: 'PractitionerInternEdit',
            component: () =>
              import(
                '@/views/provider/practitionerIntern/PractitionerInternEdit.vue'
              ),
          },
        ],
      },
      ...provideRoutes,
    ],
  },
];

export default routes;
